
import { setDefaultOptions, format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

// Configurar locale português brasileiro globalmente
setDefaultOptions({
  locale: ptBR,
});

// Função para obter a data atual no timezone de São Paulo
export const getCurrentDateInSaoPaulo = (): Date => {
  const now = new Date();
  // Converter para o timezone de São Paulo (UTC-3)
  const saoPauloOffset = -3 * 60; // -3 horas em minutos
  const utc = now.getTime() + (now.getTimezoneOffset() * 60000);
  const saoPauloTime = new Date(utc + (saoPauloOffset * 60000));
  return saoPauloTime;
};

// Função para criar uma data no timezone de São Paulo
export const createDateInSaoPaulo = (year: number, month: number, day: number): Date => {
  // Criar data assumindo timezone de São Paulo
  const date = new Date(year, month, day);
  return date;
};

// Função para formatar data sempre em português brasileiro
export const formatDateInPortuguese = (date: Date, formatString: string): string => {
  return format(date, formatString, { locale: ptBR });
};

// Função para converter string YYYY-MM-DD para Date sem problemas de timezone
export const parseDateString = (dateString: string): Date => {
  const [year, month, day] = dateString.split('-').map(Number);
  // Criar data local sem conversão de timezone
  return new Date(year, month - 1, day);
};

// Função para obter o primeiro dia do mês atual no timezone de São Paulo
export const getCurrentMonthStart = (): string => {
  const now = getCurrentDateInSaoPaulo();
  const year = now.getFullYear();
  const month = now.getMonth();
  const firstDay = new Date(year, month, 1);
  return format(firstDay, 'yyyy-MM-dd');
};

// Função para obter o último dia do mês atual no timezone de São Paulo
export const getCurrentMonthEnd = (): string => {
  const now = getCurrentDateInSaoPaulo();
  return format(now, 'yyyy-MM-dd');
};

// Função para obter o primeiro dia do ano atual no timezone de São Paulo
export const getCurrentYearStart = (): string => {
  const now = getCurrentDateInSaoPaulo();
  const year = now.getFullYear();
  const firstDay = new Date(year, 0, 1);
  return format(firstDay, 'yyyy-MM-dd');
};

// Função para obter o último dia do ano atual no timezone de São Paulo
export const getCurrentYearEnd = (): string => {
  const now = getCurrentDateInSaoPaulo();
  const year = now.getFullYear();
  const lastDay = new Date(year, 11, 31);
  return format(lastDay, 'yyyy-MM-dd');
};

export { ptBR };
